// Single source of truth for the page title shown in the topbar.
// FE bk drove this from per-page hard-codes; we centralise to avoid
// duplicating between topbar and PageHeader. When a page wants in-content
// section headers, PageHeader stays — but the topbar always reads here.
//
// Keys are exact pathname matches. For nested routes (e.g.
// /orders/:id), longest-prefix wins; see lookupRouteTitle below.

const TITLES: Record<string, string> = {
  "/dashboard": "Tổng quan",
  // Trang trung gian sau đăng nhập — chuyển ngay sang Lịch chụp / Tổng quan.
  "/home": "Đang mở…",
  "/director-board": "Bảng Giám Đốc",
  "/viec-can-xem": "Việc cần xem",
  "/kho-y-tuong": "Kho Ý Tưởng",
  "/orders": "Đơn hàng",
  "/orders/new": "Tạo đơn mới",
  "/quote-approvals": "Duyệt báo giá",
  "/quote-print": "Tờ báo giá",
  "/customers": "Khách hàng",
  "/customer-chats": "Chat khách",
  // Đường cũ, nay chuyển hướng về /complaints (gộp 25/09/2026). Giữ tên để
  // thanh tiêu đề không nháy chữ mặc định trong lúc chuyển.
  "/customer-voice": "Tiếng khách",
  "/schedule": "Lịch chụp",
  "/payments": "Thanh toán",
  "/printer-invoices": "Đối soát nhà in",
  "/cash-drawer": "Két ca tôi",
  "/cash-chain": "Sức khoẻ két",

  "/cskh": "CSKH",
  "/cskh/retouch": "Sửa hình (CSKH)",
  "/cskh/complaint": "Khiếu nại (CSKH)",
  "/cskh/upsale": "Đơn in & bán thêm",
  "/cskh/manage": "Quản lý CSKH",
  "/complaints": "Khiếu nại",
  "/retouch": "Hậu kỳ",
  "/print-ops": "Hàng in về cơ sở",
  "/print-ops-report": "Vận hành in",
  "/retouch-dispatch-settings": "Máy chia việc sửa hình",
  "/albums": "Quản lý album",
  "/albums/ledger": "Sổ album ngoài đơn",
  "/compose-backdrops": "Kho ảnh nền",
  "/gallery/albums": "Album ngoài đơn",
  "/photo-work": "Việc thợ chụp",
  "/gallery/orders": "Album",
  "/quality": "Đánh giá",
  "/qc-board": "Chất lượng nhân sự",
  "/branch-scores": "Điểm cơ sở",
  "/qc-overview": "Bảng QC",
  "/qc-desk": "Bàn làm việc QC",
  "/qc-desk/hau-kiem": "Hậu kiểm ảnh gốc",
  "/qc-desk/anh-the": "Ảnh thẻ",
  "/qc-desk/hanh-trinh": "Soi hành trình khách",
  "/store-board": "Điều phối ảnh thẻ",
  "/set-board": "Bảng set chụp",
  "/spot-checks": "Sổ khách bí mật",

  "/staff": "Nhân viên",
  "/medals": "Khen thưởng",
  "/letan-shifts": "Đăng ký ca lễ tân",
  "/ekip-shifts": "Đăng ký ca",
  "/staff-checkins": "Chấm công",
  "/staff-productivity": "Năng suất nhân sự",
  "/my-dispatch": "Suất của tôi",
  "/ekip-pool": "Nhận đơn",
  "/dispatch-board": "Bảng suất cơ sở",
  "/dispatch-points": "Điểm hành vi",
  "/fraud-board": "Chống gian lận",
  "/dispatch-settings": "Cài đặt máy chia đơn",
  "/branch-shifts": "Ca vận hành cơ sở",
  "/ekip-config": "Cấu hình Ekip",
  "/general-settings": "Cài đặt chung",
  "/integrations": "API keys",
  "/payroll": "Bảng lương",
  "/salary-rules": "Quy tắc lương",
  // Nhãn giống hệt mục menu ("Cơ chế lương v2"), KHÔNG lấy tiêu đề PageHeader
  // của trang ("Cơ chế lương"): hai trang lương nằm cạnh nhau trong menu, bỏ
  // chữ v2 trên thanh tiêu đề là người dùng không biết mình đang ở màn nào.
  "/salary-rules-v2": "Cơ chế lương v2",
  "/salary-analytics": "Phân tích lương",
  "/rankings": "Xếp hạng",
  "/mgmt-performance": "Hiệu suất quản lý",
  "/sales-team": "Phòng Kinh doanh",

  "/products": "Sản phẩm & Bảng giá",
  "/costumes": "Concept & Trang phục",
  "/tra-do": "Tra đồ",
  // /concept-guides chỉ còn là cửa chuyển hướng về /costumes?tab=guides (quyết
  // định 0096 câu 7b). routeTitles.test.ts đòi MỌI tuyến trong routeTree có
  // tiêu đề nên giữ dòng này; đặt trùng trang đích để thanh tiêu đề không
  // nháy chữ cũ trong tích tắc trước khi chuyển.
  "/concept-guides": "Concept & Trang phục",
  "/promos": "Khuyến mãi",
  "/affiliates": "Giới thiệu & hoa hồng",
  "/marketing": "Marketing",
  "/zalo": "Zalo ZNS",

  "/regulations": "Nội quy & Quy trình",
  "/sealed-inbox": "Tố giác & Góp ý",
  "/sealed-inbox-reader": "Hộp thư kín",
  "/hunch-room": "Phòng máy",
  "/expenses": "Chi phí",
  "/expense-claims": "Khoản chi của tôi",
  "/kenh-nhan-su": "Kênh nhân sự",
  "/notifications": "Thông báo của tôi",
  "/me": "Của tôi",
  "/me/collection": "Bộ sưu tập",
  "/me/journey": "Hành trình mỗi ngày",
  "/obligations": "Sổ hạn trọng yếu",
  "/equipment-overdue": "Đồ quá hạn",
  "/kho": "Kho",
  "/muon-tra-do": "Mượn / trả đồ",
  "/business-plan": "Kế hoạch KD",
  "/reports": "Báo cáo",
  "/branch-kpi": "KPI doanh thu chi nhánh",
  "/half-day-slots": "Suất buổi 5 tiếng",
  "/performance": "Hiệu suất của tôi",
  "/performance/review": "Chấm điểm",
  "/performance/admin": "Điều hành khung hiệu suất",
  "/suggestions": "Gợi ý sản phẩm",

  "/login": "Đăng nhập",
  "/auth/callback": "Đang xử lý đăng nhập…",
};

/**
 * Resolve the page title for a given pathname. Tries exact match first,
 * then walks up path segments so `/orders/abc-123` finds `/orders`.
 * Returns "GẠO NÂU ERP" as the fallback so the topbar always shows something.
 */
export function lookupRouteTitle(pathname: string): string {
  if (TITLES[pathname]) return TITLES[pathname];
  const parts = pathname.split("/").filter(Boolean);
  while (parts.length > 0) {
    parts.pop();
    const candidate = "/" + parts.join("/");
    if (TITLES[candidate]) return TITLES[candidate];
  }
  return "GẠO NÂU ERP";
}
